/* eslint-disable import/prefer-default-export */
import get from 'lodash/get';

export const authorizationFailureInterceptor = [
  response => response,
  async error => {
    if (get(error, 'response.status') === 401) {
      window.location.replace('/login');
    }

    return Promise.reject(error);
  },
];
